import React from 'react';

const ReplyIcon = () => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 18L0 9L11 0V5.625C17.0753 5.625 22 10.6616 22 16.875C22 17.1821 21.989 17.4859 21.9648 17.7862C20.306 14.5687 17.0038 12.375 13.2 12.375H11V18Z" fill="#1CA5E0" />
  </svg>
);

export default ReplyIcon;
